export abstract class FileUploadError extends Error {
  public handled: boolean | undefined;
  public networkError: boolean | undefined;
}

export class S3UploadError extends FileUploadError {
  public handled = true;

  constructor(cause: unknown) {
    super("[FileUploadError] Error uploading files to S3", { cause });
  }
}

export class UppyUploadError extends FileUploadError {
  public handled = true;

  constructor(cause: unknown) {
    super("[FileUploadError] Error uploading files with Uppy", { cause });

    const isNetworkError = cause && typeof cause === "string" && cause.toLowerCase().includes("network error");
    if (isNetworkError) {
      this.networkError = true;
    }
  }
}

export class MediaDescriptionGeneratorError extends FileUploadError {
  public handled = true;

  constructor(cause: unknown) {
    super("[FileUploadError] Error generating media description", { cause });
  }
}
